import journal from '../img/journal.png'
import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontFooter from './footer'

export default class FrontCancelled extends React.Component {
    
    constructor(props) {
        super(props);
    }


    render() {
        const params = this.props.devis.params
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage
        }
        return <><div className="titlebox">
            Votre souscription 
            <div className="hr"><img src={journal} className="journal"/></div>
        </div>
        <div className="container">
            <div className="contentbox_margin"/>

            <div className="contentbox">
            <p className="main_line">
                Ce dossier a été annulé.
            </p>
            <FrontFooter/>
            </div>
            <div className="contentbox_middle"/>

            <div className="contentbox contentbox_right">
                <FrontRecapitulatif devis={this.props.devis} container={container}/>

                <h1 className="subscribe">Contactez nous par téléphone</h1>
                <a href="tel:0974772861" className="tel">09 74 77 28 61</a>
            </div>
            <div className="contentbox_margin"/>

            </div>
        </>
    }
}